import qs from 'qs';

import axios from 'axios';
import {
    GET_ATTRACTIONS,
    GET_ATTRACTION_DETAIL,
    GET_EVENTS,
    GET_EVENT_DETAIL,
    GET_RIVERS,
    GET_RIVER_DETAIL,
    GET_TOUR_DETAIL,
    GET_PHOTO,
    GET_COMMON_MAPPINGS,
    GET_BANNERS,
    PROXY_WRS_TAICHUNG,
    PROXY_TOURISM_TAICHUNG,
    POST_COLLECTION_SEND_GMAIL,
    GET_OPEN_API_COLLECTIONS,
    GET_OPEN_API_COLLECTION_DETAIL,
    GET_OPEN_API_QRCODES,
} from './constants';

/**
 * 參數物件轉為url encode
 * @param {Object} obj 參數物件
 */
// eslint-disable-next-line no-unused-vars
function getUrlencode(obj, paramBegin = 'param') {
    let urlencode = '';
    const paramB = paramBegin;
    Object.keys(obj).forEach((key) => {
        if (Array.isArray(obj[key])) {
            obj[key].forEach((arrayKey) => {
                urlencode += `${
                    paramBegin ? `${paramB}.` : ''
                }${encodeURIComponent(key)}=${encodeURIComponent(arrayKey)}&`;
            });
        } else {
            urlencode += `${paramBegin ? `${paramB}.` : ''}${encodeURIComponent(
                key,
            )}=${encodeURIComponent(obj[key])}&`;
        }
    });
    return urlencode;
}

const request = axios.create({
    baseURL:
    process.env.NODE_ENV === 'development' ? '' : process.env.VUE_APP_API,
    timeout: 10000,
});

// 景點
export const apiAttractions = (data) => request.get(GET_ATTRACTIONS, { params: data });
export const apiAttractionDetail = (data) => request.get(`${GET_ATTRACTION_DETAIL}/${data}`);

// 活動
export const apiEvents = (data) => request.get(GET_EVENTS, {
    params: data,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});
export const apiEventDetail = (data) => request.get(`${GET_EVENT_DETAIL}/${data}`);

// 河川
export const apiRivers = (data) => request.get(GET_RIVERS, { params: data });
export const apiRiverDetail = (data) => request.get(`${GET_RIVER_DETAIL}/${data}`);

// 分眾導覽
export const apiTourDetail = (data) => request.get(`${GET_TOUR_DETAIL}?TourType=${data}`);

// 圖片
export const apiPhoto = (data) => request.get(`${GET_PHOTO}/${data}`);
export const apiPhotoUrl = process.env.VUE_APP_API + GET_PHOTO;

// 共通性資料
export const apiMappings = () => request.get(GET_COMMON_MAPPINGS);

//  Banner
export const apiBanners = () => request.get(GET_BANNERS);

// 數位集章
export const apiGetOpenApiCollections = (params) => request.get(GET_OPEN_API_COLLECTIONS, { params });
export const apiGetOpenApiCollectionDetail = (id) => request.get(`${GET_OPEN_API_COLLECTION_DETAIL}/${id}`);
export const apiPostCollectionSendGmail = (formData, params) => request.post(
    `${POST_COLLECTION_SEND_GMAIL}?${getUrlencode(params, '')}`,
    formData,
);

// QRCode
export const apiGetOpenApiQrcodes = (params) => request.get(GET_OPEN_API_QRCODES, { params });

//  已過水API
export const apiTcData = (data) => request.get(PROXY_WRS_TAICHUNG, { params: data });
export const apiTcTourData = (data) => request.get(PROXY_TOURISM_TAICHUNG, { params: data });
